import React from 'react';
import { Platform, StyleSheet } from 'react-native';

import { useAppTheme } from '@context/ThemeContext';
import MaterialCommunityIcons from '@expo/vector-icons/MaterialCommunityIcons';

export default function Icon(props: React.ComponentProps<typeof MaterialCommunityIcons>) {
  const appTheme = useAppTheme();
  return <MaterialCommunityIcons color={appTheme.colors.accent} size={24} {...props} />;
}

export function ShadowIcon({ style, ...props }: React.ComponentProps<typeof Icon>) {
  return <Icon style={[styles.shadow, style]} {...props} />;
}

export function WhiteIcon({ style, ...props }: React.ComponentProps<typeof Icon>) {
  return <Icon color="white" style={[styles.shadow, style]} {...props} />;
}

const styles = StyleSheet.create({
  shadow: {
    ...Platform.select({
      default: {
        textShadowColor: 'black',
        textShadowOffset: {
          width: 0,
          height: 2,
        },
        textShadowRadius: 5,
      },
      web: {
        textShadow: '0px 2px 5px black',
      },
    }),
  },
});
